import React from "react";
import { Field, Form } from "react-final-form";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { Switch } from "../../../components/inputs/final_form/Switch";
import { LoadingButton } from "../../../components/LoadingButton";
import { required } from "../../../util/validators";
import { camelizeKeys } from "../../../util/helpers";

export const BoxDirectoryForm = ({ handleAction, directory, showDocumentIngestion }) => {
  return (
    <Form onSubmit={handleAction} initialValues={camelizeKeys({ ...directory })}>
      {({ handleSubmit, submitting }) => {
        return (
          <>
            <Field component={TextInput} required validate={required} label="Box Folder Id" name="boxFolderId" />
            {showDocumentIngestion && (
              <div className="my-3">
                <Field component={Switch} type="checkbox" label="Document Ingestion" name="isDocumentIngestion" />
              </div>
            )}
            <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
              Save
            </LoadingButton>
          </>
        );
      }}
    </Form>
  );
};
